import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import app from './modules/app'
import tab from './modules/tab'
import user from './modules/user'
import menu from './modules/menu'
import dictionarys from './modules/dictionary'

const store = new vuex.Store({
    modules: {
        app: app,
        tab: tab,
        user: user,
        menu: menu,
        dictionary: dictionarys
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js